module.exports = __webpack_public_path__ + "static/media/contacts.843bb6e4.svg";